export default "__VITE_ASSET__70cd8a8a__"